import $http from '@/api/index'
import {
  getToken
} from '../../../util/auth'


//添加人员职务
export function addUserJobData(para) {
  let options = {
    method: 'POST',
    url: 'emergencybasedata/AddorUpdateDutyInfo',
    requestType: 11
  }
  let params = para;
  return $http(options, params);
}

//根据Id  删除人员职务
export function deleteUserJobData(Id) {
  let options = {
    method: 'POST',
    url: `emergencybasedata/DeleteDutyInfoById?Id=${Id}`,
    requestType: 11
  }
  let params = {}
  return $http(options, params);
}

//获取人员职务列表
export function getUserJobList(prm) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/GetAllDutyInfoListBystate',
    requestType: 11
  }
  let params = prm;
  return $http(options, params);
}
//人员职务创建时防止重复名称
export function noDuplication(prm) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/JudgeDutyExistName',
    requestType: 11
  }
  let params = prm;
  return $http(options, params);
}

//添加人员信息
export function upDateUserInfo(data) {
  let options = {
    method: 'POST',
    url: 'emergencybasedata/AddorUpdateEmergencyUserInfo',
    requestType: 11,
    isJsonData: true
  }
  let params = data
  return $http(options, params);
}

// 人员删除接口
export function deleteUserInfo(data) {
  let options = {
    method: 'POST',
    url: `emergencybasedata/DeleteEmergencyUserById?Id=${data.Id}&CreateUserid=${data.CreateUserid}`,
    requestType: 11
  }
  let params = {};
  return $http(options, params);
}
// 人员切换状态接口
export function SwitcUserState(data) {
  let options = {
    method: 'POST',
    url: `emergencybasedata/ChangeUserStateByUserId?UserId=${data.UserId}&ChangeState=${data.ChangeState}&CreateUserid=${data.CreateUserid}`,
    requestType: 11
  }
  let params = {};
  return $http(options, params);
}
//职务切换状态
export function handleSwitcState(data) {
  let options = {
    method: 'POST',
    url: `emergencybasedata/ChangeDutyStateById?DutyId=${data.DutyId}&ChangeState=${data.ChangeState}&CreateUserid=${data.CreateUserid}`,
    requestType: 11
  }
  let params = {};
  return $http(options, params);
}


//行政人员的统计
export function getAdminiStrationCount(pam) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/GetAdminUserStaticInfo',
    requestType: 11
  }
  let params = pam;
  return $http(options, params);
}

//医生人员的统计
export function getDoctorCount(pam) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/GetDoctorStaticInfo',
    requestType: 11
  }
  let params = pam;
  return $http(options, params);
}

//护士人员的统计
export function getNurseCount(pam) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/GetNurseStaticInfo',
    requestType: 11
  }
  let params = pam;
  return $http(options, params);
}

// 获取人员列表数据

export function getUserListData(pam) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/GetNewEmergencyUserSearchResultCount',
    requestType: 11
  }
  let params = pam;
  return $http(options, params);
}

// 获取人员职称数据
export function getjobTitleData(pam) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/GetDictInfoListByType',
    requestType: 11
  }
  let params = pam;
  return $http(options, params);
}

// 获取执业类别和范围
export function getSortRange(pam) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/GetAllPracticeTypeList',
    requestType: 11
  }
  let params = pam;
  return $http(options, params);
}
// 根据id获取用户详情
export function GetCurrentEmergencyUserInfoById(pam) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/GetCurrentEmergencyUserInfoById',
    requestType: 11
  }
  let params = pam;
  return $http(options, params);
}